module.exports = __webpack_public_path__ + "static/media/Serpro.ade40214.svg";